module.exports = __webpack_public_path__ + "static/widget-img-8-061a0347eb0f6dd6d0ab503c0aaffd87.png";